import { IM100RichTextModule } from '~/lib/data-contract';
import { RawHtml } from '~/shared/components/RawHtml/RawHtml';
import { M100RichTextTitle } from '~/templates/blocks/components/M100RichText/components/M100RichTextTitle/M100RichTextTitle';
import { StyledM100RichText } from '~/templates/blocks/components/M100RichText/styled';
import { ModuleContainer } from '../ModuleContainer/ModuleContainer';

export type M100RichTextProps = IM100RichTextModule;

export const M100RichText = ({ id, text, headline, layout, brandEffect, moduleBackgroundColor, anchorId }: M100RichTextProps) => {
	return (
		<ModuleContainer
			hasGutter={true}
			id={id}
			anchorId={anchorId?.toLowerCase()}
			brandEffect={brandEffect}
			moduleBackgroundColor={moduleBackgroundColor}
		>
			<StyledM100RichText layout={layout}>
				<M100RichTextTitle
					headline={headline}
					brandEffect={brandEffect}
				/>
				{text ? (
					<RawHtml
						layout={layout}
						html={text.html}
					/>
				) : null}
			</StyledM100RichText>
		</ModuleContainer>
	);
};
